import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.2334 6.70001H12.7667V14.5H3.2334V6.70001Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.96631 6.7V4.53333C4.96631 3.72884 5.28589 2.9573 5.85475 2.38844C6.42361 1.81958 7.19515 1.5 7.99964 1.5C8.80413 1.5 9.57567 1.81958 10.1445 2.38844C10.7134 2.9573 11.033 3.72884 11.033 4.53333V6.7",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00049 9.73334V11.4667",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLock;
